import React from 'react';

const TherapyService = () => {
  return <div className="min-h-screen pt-24 container-custom"><h1 className="text-2xl">Physical Therapy</h1><p>Coming soon</p></div>;
};

export default TherapyService;